import { render, staticRenderFns } from "./tags-list-single.vue?vue&type=template&id=058d65ec&"
import script from "./tags-list-single.vue?vue&type=script&lang=js&"
export * from "./tags-list-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports